import { callApi } from './callApi';

export default async ({ boxID, actionType = 'Change', activity }) => {
  return callApi({
    endpoint: `boxSessions/${boxID}/addActions`,
    method: 'POST',
    body: {
      actions: [
        {
          actionType,
          description: activity,
        },
      ],
    },
  });
};
